import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import Sidebar from '../../components/Sidebar';
import GeneralIcon from '../../assets/index';
import { clearMockStore } from '../../services/storeCreationService';

export default function FullDashboard({ store }) {
	const navigate = useNavigate();
	// initialize from localStorage so the last state is preserved
	const [sidebarOpen, setSidebarOpen] = useState(() => {
		try {
			return localStorage.getItem('sidebar:open') === 'true';
		} catch (e) {
			return false;
		}
	});

	useEffect(() => {
		const openHandler = () => setSidebarOpen(true);
		window.addEventListener('openSidebar', openHandler);
		return () => window.removeEventListener('openSidebar', openHandler);
	}, []);

	// Persist state and expose global helpers
	useEffect(() => {
		try {
			localStorage.setItem('sidebar:open', sidebarOpen ? 'true' : 'false');
		} catch (e) {
			// ignore
		}

		// expose simple global functions while component is mounted
		window.setSidebarState = (val) => {
			try {
				localStorage.setItem('sidebar:open', val ? 'true' : 'false');
			} catch (e) {}
			setSidebarOpen(!!val);
		};
		window.getSidebarState = () => {
			try {
				return localStorage.getItem('sidebar:open') === 'true';
			} catch (e) {
				return false;
			}
		};

		return () => {
			try {
				delete window.setSidebarState;
				delete window.getSidebarState;
			} catch (e) {}
		};
	}, [sidebarOpen]);

	return (
		<div className="min-h-screen flex flex-col items-center bg-white">
			{/* Sidebar component */}
			<Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

			<div className="w-full flex flex-col items-center pt-10">
				<GeneralIcon iconName={"Geppro_Seller"} className="h-8 w-auto mt-5 mb-10" />

				<div className="flex items-center justify-center gap-3 mb-10 select-none">
					<button
						aria-label="menu"
						onClick={() => setSidebarOpen(true)}
						className="bg-gray-100 w-10 h-9 rounded-lg flex flex-col items-center justify-center text-gray-600 shadow-sm gap-1"
					>
						<div className="w-5 h-0.5 bg-gray-600 rounded" />
						<div className="w-5 h-0.5 bg-gray-600 rounded" />
						<div className="w-5 h-0.5 bg-gray-600 rounded" />
					</button>

					<div className="bg-gray-100 text-black h-9 rounded-lg min-w-[12rem] px-4 flex items-center justify-center text-sm shadow-sm select-none">
						{store?.name || 'Minha loja'}
					</div>

					<button
						aria-label="profile"
						onClick={() => navigate('/conta_do_vendedor')}
						className="bg-gray-100 w-10 h-9 rounded-lg flex items-center justify-center text-gray-600 shadow-sm"
					>
						<GeneralIcon iconName={"User"} className="h-5 w-auto mb-0.2" />
					</button>
				</div>
			</div>

			<div className="w-full max-w-3xl mx-auto text-center mb-6 px-6">
				<h1 className="text-4xl font-semibold text-gray-800">Bem vindo</h1>
				<p className="text-3xl text-gray-700 mt-1">de volta à sua loja!</p>
			</div>

			<main className="flex-1 flex items-start justify-center w-full px-6">
				<div className="max-w-md w-full text-center mx-auto">
					<div className="flex items-center justify-center mb-5">
						
					</div>

					<h2 className="text-xl font-semibold mb-2">Status da Loja</h2>
					{store?.cnaes?.length ? (
						<p className="text-gray-600">{store.cnaes.length} CNAE(s) configurado(s). Última atualização: {new Date(store.createdAt).toLocaleString()}</p>
					) : (
						<p className="text-gray-600">Nenhum CNAE aplicado ainda.</p>
					)}

					{store?._mock && (
						<button
							onClick={() => { clearMockStore(); window.location.reload(); }}
							className="mt-4 text-xs px-3 py-2 rounded-md bg-red-100 text-red-600 hover:bg-red-200 font-medium"
						>
							Limpar Mock
						</button>
					)}
				</div>
			</main>
		</div>
	);
}